import { useCallback } from "react";

import { useMutation } from "react-query";

import { getSecuredURL } from "../apis/securedUrlApi";

export const useSecuredUrl = (): {
    onSecureUrlClick: (linkUrl: string) => void;
} => {
    const getFullUrl = (url: string): string => {
        if (!/^https?:\/\//i.test(url)) {
            return "https://" + url; // Prepend https:// if missing
        }
        return url;
    };

    const mutation = useMutation((linkUrl: string) => getSecuredURL(linkUrl), {
        onSuccess: (securedUrl: string) => {
            const url = getFullUrl(securedUrl);
            window.open(url, "_blank");
        },
    });

    const handleInsurerLinkClick = useCallback(
        (linkUrl: string) => {
            mutation.mutate(linkUrl);
        },
        [mutation],
    );

    return {
        onSecureUrlClick: handleInsurerLinkClick,
    };
};

export default useSecuredUrl;
